<template>
  <optional-field :enabled.sync="enabled" :name="field.name">
    <v-checkbox
      v-model="localData"
      :label="field.name"></v-checkbox>
  </optional-field>
</template>

<script>
import Field from '@/mixins/JsonEditorField'
import OptionalField from './OptionalField'

export default {
  name: 'JsonTags',
  components: { OptionalField },
  mixins: [Field]
}
</script>
